<template>
  <div
    class="seckill-count-down"
    :style="module.countDownStyle"
    @click="onGoSpike(module.data.rows[0].ssuList[0])"
  >
    <div v-if="module.showCountDown" class="sec-kill-time">
      <div class="sec-kill-time-hour" :style="module.countDownTextStyle">
        {{ time.hour }}
      </div>
      :
      <div class="sec-kill-time-minute" :style="module.countDownTextStyle">
        {{ time.minute }}
      </div>
      :
      <div class="sec-kill-time-sec" :style="module.countDownTextStyle">
        {{ time.sec }}
      </div>
    </div>
    <div class="more">
      更多
      <IconFont name="mc-icon-arrowright" size="0.24rem" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    module: {
      type: Object,
      default: () => ({})
    },
    countDownStyle: {
      type: Object,
      default: () => ({})
    },
    countDownTextStyle: {
      type: Object,
      default: () => ({})
    },
    moduleId: {
      type: String,
      default: ''
    },
    event: {
      type: String,
      default: ''
    },
    onGoSpike: {
      type: Function,
      default: () => {}
    },
    addListener: {
      type: Function,
      default: () => {}
    },
    removeListener: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      time: {
        hour: '',
        minute: '',
        sec: ''
      }
    }
  },
  watch: {
    module: {
      handler: function () {
        this.handle()
      },
      deep: true
    }
  },
  created() {
    this.handle()
  },
  destroyed() {
    this.remove()
  },
  methods: {
    handle() {
      this.addListener(this.event, hms => {
        this.time = hms
      })
    },
    remove() {
      this.removeListener(this.event, this._handlerId)
    }
  }
}
</script>
<style lang="scss" scoped>
.seckill-count-down {
  position: relative;

  width: 100%;
  height: 0.64rem;
  background-size: contain;

  background-repeat: no-repeat;
  .sec-kill-time {
    display: flex;

    position: absolute;
    top: 0.16rem;
    left: 1.76rem;

    height: 0.32rem;

    align-items: center;

    font-size: 0.24rem;
    text-align: center;
    color: #f03100;

    &-hour,
    &-minute,
    &-sec {
      width: 0.32rem;
      height: 0.32rem;

      background-color: #ff6200;

      border-radius: 0.08rem;

      line-height: 0.32rem;
      color: #fff;
    }
    &-hour {
      margin-right: 0.04rem;
    }
    &-minute {
      margin: 0 0.04rem;
    }
    &-sec {
      margin-left: 0.04rem;
    }
  }
  .more {
    display: flex;

    position: absolute;
    top: 0.2rem;
    right: 0.2rem;

    align-items: center;
    @include text(0.24rem, #8c8c8c);
  }
}
</style>
